/* ==========================================================================
   SMOON — Landing « Sports techniques »
   Carrousels, onglets, sélecteurs de variante (simple ou couleur + taille),
   ajout panier AJAX, guide des tailles et apparitions au scroll.
   Vanilla, sans dépendance, idempotent (sûr avec l'éditeur de thème).
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.spt[data-spt-root]';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    var f = window.Shopify && window.Shopify.money_format;
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (f && f.indexOf('{{') > -1) {
      return f.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return v + ' €';
  }

  /* ------------------------------------------------------------ carrousels
     Défilement natif en scroll-snap : le JS ne gère que flèches, points et
     miniatures. Les positions visent l'offset réel des diapos, sinon le
     padding de la piste décale chaque saut. */
  function initSlider(vp) {
    if (vp.dataset.sptSlider) return;
    vp.dataset.sptSlider = '1';

    var track = vp.matches('[data-spt-track]') ? vp : null;
    if (!track) {
      var cands = vp.querySelectorAll('[data-spt-track]');
      for (var c = 0; c < cands.length; c++) {
        var owner = cands[c].closest('[data-spt-slider]');
        if (!owner || owner === vp) { track = cands[c]; break; }
      }
    }
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function scroller() {
      return track.scrollWidth > track.clientWidth + 1 ? track : vp;
    }

    function ctrl(sel) {
      var scopes = [vp, vp.parentElement, vp.parentElement && vp.parentElement.parentElement, vp.closest('section')];
      for (var i = 0; i < scopes.length; i++) {
        if (!scopes[i]) continue;
        var els = scopes[i].querySelectorAll(sel);
        for (var j = 0; j < els.length; j++) {
          var owner = els[j].closest('[data-spt-slider]');
          if (owner && owner !== vp) continue;
          return els[j];
        }
      }
      return null;
    }

    var dotsBox = ctrl('[data-spt-dots]');
    var thumbsBox = ctrl('[data-spt-thumbs]');
    var prev = ctrl('[data-spt-prev]');
    var next = ctrl('[data-spt-next]');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.children) : [];
    var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.children) : [];

    function offsetOf(i) {
      return Math.max(0, slides[i].offsetLeft - slides[0].offsetLeft);
    }

    function current() {
      var sl = scroller().scrollLeft;
      var best = 0;
      var bd = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var d = Math.abs(offsetOf(k) - sl);
        if (d < bd) { bd = d; best = k; }
      }
      return best;
    }

    function paint(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var sc = scroller();
      var noScroll = sc.scrollWidth <= sc.clientWidth + 2;
      if (prev) prev.disabled = noScroll || sc.scrollLeft <= 2;
      if (next) next.disabled = noScroll || sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2;
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      scroller().scrollTo({ left: offsetOf(i), behavior: smooth === false ? 'auto' : 'smooth' });
      paint(i);
    }
    vp.sptGoTo = goTo;

    var raf;
    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(current()); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if (vp !== track) vp.addEventListener('scroll', onScroll, { passive: true });

    /* une flèche = une carte, comme attendu par les visiteuses */
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });

    paint(0);
    window.addEventListener('resize', function () { paint(current()); }, { passive: true });
  }

  /* --------------------------------------------------------------- onglets */
  function initTabs(root) {
    $$('[data-spt-tab]', root).forEach(function (tab) {
      if (tab.dataset.sptInit) return;
      tab.dataset.sptInit = '1';
      tab.addEventListener('click', function () {
        var host = tab.closest('.spt-equip__in') || root;
        $$('[data-spt-tab]', host).forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-spt-panel]', host).forEach(function (p) {
          p.classList.toggle('is-hidden', p.dataset.sptPanel !== tab.dataset.sptTab);
        });
        /* les rails du panneau révélé n'avaient pas de largeur mesurable */
        $$('[data-spt-slider]', host).forEach(function (s) { if (s.sptGoTo) s.sptGoTo(0, false); });
      });
    });
  }

  /* ------------------------------------------ variantes, options et panier */
  function initProductForm(scope) {
    if (scope.dataset.sptForm) return;
    scope.dataset.sptForm = '1';

    var dataEl = scope.querySelector('[data-spt-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = scope.querySelector('[data-spt-variant]');
    var optSelects = $$('[data-spt-opt]', scope);
    var input = scope.querySelector('[data-spt-id]');
    var btn = scope.querySelector('[data-spt-add]');
    var lbl = btn ? btn.querySelector('[data-spt-lbl]') : null;
    var priceEl = scope.querySelector('[data-spt-price]');
    var gallery = scope.querySelector('[data-spt-slider]');

    function byId(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    /* couleur + taille : on recompose la variante depuis les deux listes */
    function byOptions() {
      var chosen = optSelects.map(function (s) { return s.value; });
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var k = 0; k < chosen.length; k++) {
          if (String((v.opts || [])[k]) !== String(chosen[k])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    var booted = false;

    function sync() {
      var v = optSelects.length ? byOptions() : byId(select ? select.value : (input && input.value));
      if (!v) {
        /* combinaison inexistante : on neutralise plutôt que de mentir */
        if (btn) { btn.disabled = true; if (lbl) lbl.textContent = data.labelOut || ''; }
        return;
      }
      if (input) input.value = v.id;

      if (booted && gallery && gallery.sptGoTo && data.leadIdx) {
        var idx = data.leadIdx[String(v.id)];
        if (typeof idx === 'number') gallery.sptGoTo(idx);
      }
      if (priceEl && !priceEl.dataset.sptFixed) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        if (lbl) lbl.textContent = v.available ? (data.labelAdd || '') : (data.labelOut || '');
      }
    }

    if (select) select.addEventListener('change', sync);
    optSelects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
    booted = true;

    var form = scope.querySelector('[data-spt-cart-form]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-load')) return;
      btn.classList.add('is-load');

      var body = new FormData(form);
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.location.href = form.action; return; }
          if (drawer) {
            if (drawer.classList && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer.renderContents) drawer.renderContents(res);
            if (drawer.open) drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('spt:added', { detail: res }));
        })
        .catch(function () { window.location.href = form.action; })
        .finally(function () { btn.classList.remove('is-load'); });
    });
  }

  /* --------------------------------------------------- guide des tailles */
  function initGuide(root) {
    $$('[data-spt-guide]', root).forEach(function (link) {
      if (link.dataset.sptInit) return;
      link.dataset.sptInit = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var modal = document.getElementById(link.dataset.sptGuide);
        if (!modal) return;
        if (typeof modal.show === 'function') modal.show(link);
        else modal.setAttribute('open', 'true');
      });
    });
  }

  /* ------------------------------------------------- ancres internes */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
    var offset = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 8, behavior: 'smooth' });
    return true;
  }

  function initAnchors(root) {
    $$('[data-spt-scroll]', root).forEach(function (a) {
      if (a.dataset.sptInit) return;
      a.dataset.sptInit = '1';
      a.addEventListener('click', function (e) { if (scrollToId(a.dataset.sptScroll)) e.preventDefault(); });
    });
    $$('a[href^="#"]', root).forEach(function (a) {
      if (a.dataset.sptInit) return;
      a.dataset.sptInit = '1';
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (id && scrollToId(id)) e.preventDefault();
      });
    });
  }

  /* ------------------------------ aide au défilement des rails mobiles */
  function initScrollHint(root) {
    $$('[data-spt-scroll-x]', root).forEach(function (box) {
      if (box.dataset.sptInit) return;
      box.dataset.sptInit = '1';
      var host = box.closest('section') || box.parentElement;
      var hint = host ? host.querySelector('[data-spt-hint]') : null;
      if (!hint) return;
      function check() {
        if (box.scrollWidth <= box.clientWidth + 2 || box.scrollLeft > 12) hint.style.visibility = 'hidden';
        else hint.style.visibility = '';
      }
      box.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    });
  }

  /* ------------------------------------------------------------ apparitions */
  function initReveal(root) {
    var els = $$('.spt-anim', root).filter(function (el) { return !el.dataset.sptSeen; });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.dataset.sptSeen = '1'; io.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    if (!root) return;
    $$('[data-spt-slider]', root).forEach(initSlider);
    $$('[data-spt-product]', root).forEach(initProductForm);
    initTabs(root);
    initGuide(root);
    initAnchors(root);
    initScrollHint(root);
    initReveal(root);
  }

  function bootAll() { $$(SEL).forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SEL) || (e.target.matches && e.target.matches(SEL) ? e.target : null);
    boot(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[data-spt-panel]');
    if (panel) {
      var host = panel.closest('.spt-equip__in');
      var tab = host ? host.querySelector('[data-spt-tab="' + panel.dataset.sptPanel + '"]') : null;
      if (tab) tab.click();
    }
  });
})();
